const state = {
  companyInfo: null,
  recruiterInfo: null,
  landscapeScreen: false,
  potraitScreen: false,
  skipBtn: [],
  interviewTracking: [],
  jobcode: [],
  selectedProd: null,
  uploadProgress: 0,
  quesBox: [],
  updateJobC: [],
  publishJobC: [],
  videoPercentage: [],
  recordingPercentage: [],
  uploadedVideoAnswers: [],
  trimmedInformation: [],
  allowedBrowsersList: {
    Windows: [
      {
        name: 'Chrome',
        downloadLink: 'https://www.google.com/chrome/',
        img: '/assets/img/browsers/chrome.png',
        supportedVersion: 80 // least supported version, check that everything works with the current verison of testing and place it here.
      },
      {
        name: 'Firefox',
        downloadLink: 'https://www.mozilla.org/firefox/new/',
        img: '/assets/img/browsers/firefox.png',
        supportedVersion: 78
      },
      {
        name: 'Opera',
        downloadLink: 'https://www.opera.com/',
        img: '/assets/img/browsers/opera.png',
        supportedVersion: 70
      }
      // {
      //   name: 'Edge',
      //   downloadLink: 'https://www.microsoft.com/en-us/edge',
      //   img: '/assets/img/browsers/edge.png',
      //   supportedVersion: 80
      // },
      // {
      //   name: 'Brave',
      //   downloadLink: 'https://brave.com/',
      //   img: '/assets/img/browsers/brave.png',
      //   supportedVersion: 80
      // },
    ],
    macOS: [
      {
        name: 'Chrome',
        downloadLink: 'https://www.google.com/chrome/',
        img: '/assets/img/browsers/chrome.png',
        supportedVersion: 80
      },
      {
        name: 'Firefox',
        downloadLink: 'https://www.mozilla.org/en-US/firefox/new/',
        img: '/assets/img/browsers/firefox.png',
        supportedVersion: 78
      },
      {
        name: 'Opera',
        downloadLink: 'https://www.opera.com/',
        img: '/assets/img/browsers/opera.png',
        supportedVersion: 70
      },
      {
        name: 'Safari',
        downloadLink: 'https://support.apple.com/downloads/safari',
        img: '/assets/img/browsers/safari.png',
        supportedVersion: 13
      }
      // {
      //   name: 'Edge',
      //   downloadLink: 'https://www.microsoft.com/en-us/edge',
      //   img: '/assets/img/browsers/edge.png',
      //   supportedVersion: 80
      // },
      // {
      //   name: 'Brave',
      //   downloadLink: 'https://brave.com/',
      //   img: '/assets/img/browsers/brave.png',
      //   supportedVersion: 80
      // },
    ],
    Linux: [
      {
        name: 'Chrome',
        downloadLink: 'https://www.google.com/chrome/',
        img: '/assets/img/browsers/chrome.png',
        supportedVersion: 80
      },
      {
        name: 'Firefox',
        downloadLink: 'https://www.mozilla.org/en-US/firefox/new/',
        img: '/assets/img/browsers/firefox.png',
        supportedVersion: 78
      },
      {
        name: 'Opera',
        downloadLink: 'https://www.opera.com/',
        img: '/assets/img/browsers/opera.png',
        supportedVersion: 70
      }
      // {
      //   name: 'Brave',
      //   downloadLink: 'https://brave.com/',
      //   img: '/assets/img/browsers/brave.png',
      //   supportedVersion: 80
      // },
    ],
    Android: [
      {
        name: 'Chrome',
        downloadLink: 'https://www.google.com/chrome/',
        img: '/assets/img/browsers/chrome.png',
        supportedVersion: 80
      },
      {
        name: 'Firefox',
        downloadLink: 'https://www.mozilla.org/en-US/firefox/new/',
        img: '/assets/img/browsers/firefox.png',
        supportedVersion: 78
      },
      {
        name: 'Opera',
        downloadLink: 'https://www.opera.com/',
        img: '/assets/img/browsers/opera.png',
        supportedVersion: 70
      }
    ],
    iOS: [
      {
        name: 'Chrome',
        downloadLink: 'https://www.google.com/chrome/',
        img: '/assets/img/browsers/chrome.png',
        supportedVersion: 80
      },
      {
        name: 'Firefox',
        downloadLink: 'https://www.mozilla.org/en-US/firefox/new/',
        img: '/assets/img/browsers/firefox.png',
        supportedVersion: 78
      },
      {
        name: 'Opera',
        downloadLink: 'https://www.opera.com/',
        img: '/assets/img/browsers/opera.png',
        supportedVersion: 70
      }
      // {
      //   name: 'Safari',
      //   downloadLink: 'https://support.apple.com/downloads/safari',
      //   img: '/assets/img/browsers/safari.png',
      //   supportedVersion: 13
      // },
    ]
  }
}
export default state
